<template>
  <div class="text-left">
    <b-form-select
      v-model="nuevoCargoId"
      :options="this.getCharges"
      class="form-control"
    >
      <b-form-select-option :value="null">Cargo</b-form-select-option>
    </b-form-select>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "EditField",
  data() {
    return {
      selected: false,
      nuevoCargoId: null,
    };
  },
  props: ["row", "field"],
  computed: {
    ...mapState("modTipshiftReport", ["charges"]),
    ...mapGetters("modTipshiftReport", ["getCharges"]),
  },
  beforeMount() {
    this.nuevoCargoId = this.row.nuevoCargoId;
  },
  watch: {
    nuevoCargoId: function (newVal) {
      this.emitCargo(newVal);
    },
  },
  methods: {
    ...mapActions("modTipshiftReport", ["actSelectCargo"]),

    emitCargo: function (newVal) {
      let charge = this.getCharges.find(charge => charge.id === newVal);
      this.actSelectCargo({ novedad: this.row, charge: charge })
        /*.then(() => {
          console.log(this.row);
        })*/
        .catch((response) => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "No se pudo seleccionar todos los registros: " + response;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>